import {lazy, Suspense} from 'react';
import {Button} from '@mui/material';
import {Create} from '@mui/icons-material';

const LazyDataUpdate = lazy(() => import('./DataUpdate'));

const FallbackComponent = (
  <div className="DataUpdate loading" data-testid="DataUpdate">
    <Button
      variant="contained"
      color="primary"
      size="small"
      className="data-update-link"
      disableElevation
      aria-disabled
      startIcon={<Create/>}
    >
      Update
    </Button>
  </div>
);

const DataUpdate = props => (
  <Suspense fallback={FallbackComponent}>
    <LazyDataUpdate {...props} />
  </Suspense>
);

export default DataUpdate;
